import { themeColors, themeSizes } from '../../../../styles/globalStyleVars';
import OnboardingItem from './OnboardingModalItem';
import {
  commonItems,
  equipmentItem,
  ticketsItem,
} from '../../../../utils/config/Onboarding/onboardingItems';
import styled from 'styled-components';
import { TypographyStyled } from '../../../Styled/Typography';
import useBreakpoints from '../../../../hooks/useBreakpoints';
import useMediaQuery from '../../../../hooks/useMediaQuery';

interface OnboardingModalBodyProps {
  hasEquipmentPermission: boolean;
  setShowModal: (show: boolean) => void;
}

const OnboardingItemWrapper = styled.div<{
  $isLgAndUp: boolean;
  $isSmAndDown: boolean;
}>`
  display: flex;
  flex-direction: ${({ $isSmAndDown }) => ($isSmAndDown ? 'column' : 'row')};
  justify-content: center;
  // 48px between columns at lg+, 24px otherwise (md columns / stacked mobile rows).
  gap: ${({ $isLgAndUp }) => ($isLgAndUp ? themeSizes.xxl : themeSizes.lg)};
`;

const OnboardingModalBody = ({
  hasEquipmentPermission,
  setShowModal,
}: OnboardingModalBodyProps) => {
  const breakpoints = useBreakpoints();
  const isLgAndUp = useMediaQuery(breakpoints.up('lg'));
  const isSmAndDown = useMediaQuery(breakpoints.down('sm'));

  const itemsToRender = hasEquipmentPermission
    ? [...commonItems, equipmentItem]
    : [...commonItems, ticketsItem];

  return (
    <div style={{ paddingBottom: themeSizes.xl }}>
      <TypographyStyled
        text='Welcome to CFA Support! What can we help you with?'
        color={themeColors.colorGray_7}
        data-testid={'onboarding-subtitle'}
        variant='body2'
        style={{ marginBottom: isSmAndDown ? themeSizes.lg : themeSizes.xl }}
      />
      <OnboardingItemWrapper $isLgAndUp={isLgAndUp} $isSmAndDown={isSmAndDown}>
        {itemsToRender.map(item => (
          <OnboardingItem
            key={item.id}
            button={item.button}
            description={item.description}
            icon={item.icon}
            setShowModal={setShowModal}
            title={item.title}
          />
        ))}
      </OnboardingItemWrapper>
    </div>
  );
};

export default OnboardingModalBody;
